export type ModulePlan = {
  id: string;
  name: string;
  description: string;
  monthlyPrice: number;
  isFree: boolean;
};

export const MODULE_PLANS: ModulePlan[] = [
  { id: "products_sales_basic", name: "Cadastro de produtos e vendas (Básico)", description: "Até 100 produtos e vendas ilimitadas.", monthlyPrice: 0, isFree: true },
  { id: "products_sales_advanced", name: "Cadastro de produtos e vendas (Avançado)", description: "Até 5.000 produtos e vendas ilimitadas.", monthlyPrice: 19.9, isFree: false },
  { id: "products_sales_unlimited", name: "Cadastro de produtos e vendas (Ilimitado)", description: "Produtos e vendas ilimitadas.", monthlyPrice: 49.9, isFree: false },
  { id: "inventory_control", name: "Controle de estoque", description: "Plano único.", monthlyPrice: 19.9, isFree: false },
  { id: "accounts_payable", name: "Contas a pagar", description: "Plano único.", monthlyPrice: 9.9, isFree: false },
  { id: "customers_credit_basic", name: "Clientes e Fiado (Básico)", description: "Até 5 clientes.", monthlyPrice: 0, isFree: true },
  { id: "customers_credit_advanced", name: "Clientes e Fiado (Avançado)", description: "Até 500 clientes.", monthlyPrice: 29.9, isFree: false },
  { id: "customers_credit_unlimited", name: "Clientes e Fiado (Ilimitado)", description: "Clientes ilimitados.", monthlyPrice: 49.9, isFree: false },
  { id: "bulk_register", name: "Cadastro em massa", description: "Plano único.", monthlyPrice: 19.9, isFree: false },
  { id: "users_basic", name: "Controle de usuário (Básico)", description: "Até 3 usuários.", monthlyPrice: 0, isFree: true },
  { id: "users_advanced", name: "Controle de usuário (Avançado)", description: "Até 10 usuários.", monthlyPrice: 19.9, isFree: false },
  { id: "users_unlimited", name: "Controle de usuário (Ilimitado)", description: "Usuários ilimitados.", monthlyPrice: 49.9, isFree: false },
  { id: "cash_register", name: "Controle de Caixa", description: "Plano único.", monthlyPrice: 0, isFree: true },
  { id: "supplier_categories", name: "Fornecedores e Categorias", description: "Plano único.", monthlyPrice: 0, isFree: true },
  { id: "statistics_reports", name: "Estatísticas e Relatórios", description: "Plano único.", monthlyPrice: 0, isFree: true },
  { id: "commissions", name: "Comissões", description: "Plano único.", monthlyPrice: 19.9, isFree: false },
];

export interface PlanDef {
  id: string;
  name: string;
  priceLabel: string;
  period: string;
  description: string;
  features: string[];
  highlighted?: boolean;
}

const formatPrice = (value: number) =>
  value === 0 ? "R$ 0,00" : `R$ ${value.toFixed(2).replace(".", ",")}`;

export const PLANS: PlanDef[] = MODULE_PLANS.map((modulePlan) => ({
  id: modulePlan.id,
  name: modulePlan.name,
  priceLabel: formatPrice(modulePlan.monthlyPrice),
  period: "/mês",
  description: modulePlan.description,
  features: [
    modulePlan.isFree ? "Módulo gratuito" : "Módulo pago",
    "Ativação imediata no ciclo atual",
    "Cancelamento no próximo ciclo",
    "Elegível para desconto progressivo em pacote",
  ],
  highlighted: !modulePlan.isFree,
}));

export const MODULAR_ADVANTAGES = [
  "Monte seu pacote em minutos e pague só pelo que usar.",
  "Desconto progressivo automático quanto mais módulos pagos.",
  "Ciclo único para tudo: fácil de entender e escalar.",
];

export const EXCLUSIVE_FULL_BUNDLE_BONUS_BRL = 100;
export const FREE_MODULE_IDS = MODULE_PLANS.filter((m) => m.isFree).map((m) => m.id);

const getDiscountPercentByPaidModules = (count: number) => {
  if (count >= 4) return 15;
  if (count === 3) return 10;
  if (count === 2) return 5;
  return 0;
};

export function computeBundlePreview(moduleIds: string[]) {
  const selected = MODULE_PLANS.filter((m) => moduleIds.includes(m.id));
  const paid = selected.filter((m) => !m.isFree);
  const paidSubtotal = paid.reduce((acc, item) => acc + item.monthlyPrice, 0);
  const discountPct = getDiscountPercentByPaidModules(paid.length);
  const discountAmount = (paidSubtotal * discountPct) / 100;
  const finalMonthlyTotal = Math.max(0, paidSubtotal - discountAmount);
  return {
    selected,
    paidCount: paid.length,
    paidSubtotal,
    discountPct,
    discountAmount,
    finalMonthlyTotal,
  };
}

export function getPlanById(id: string): PlanDef | undefined {
  return PLANS.find((p) => p.id === id);
}
